import Vue from 'vue'
import Router from 'vue-router'
import factory from "./factory/factory";
import delivery from "./delivery/delivery";

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'login',
            component: () => import('@/layout/login'),
        },
        {...delivery},
        {...factory},
        {
            path: '/monitor',
            name: 'delivery.index',
            component: () => import('@/pages/Delivery/index'),

        }
    ]
})
